import React, { useMemo } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuTypePropType } from 'ui-components/components/dropdown-menu/dropdown-menu-type';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { noop } from 'ui-components/default-props/noop';

import messages from '../messages';

const ConfirmationOption = ({
  id,
  dropdownMenuType,
  confirmationOptions,
  selectedConfirmationOptionId,
  onChange = noop,
  className = null,
  disabled = false,
  placeholderText,
  togglerClassName,
}) => {
  const intl = useIntl();

  const selectedConfirmationOption =
    confirmationOptions.find((confirmationOption) => confirmationOption.confirmationOptionId === selectedConfirmationOptionId) || {};
  const baseDisplayValue = placeholderText || ' ';
  const selectedConfirmationOptionName = selectedConfirmationOption.name || baseDisplayValue;

  const tooltipMessage = useMemo(() => (disabled ? <FormattedMessage {...messages.confirmationNotSupported} /> : undefined), [disabled]);
  return (
    <DropdownMenu
      ariaLabel={intl.formatMessage(messages.confirmation)}
      className={className}
      disabled={disabled}
      disabledTooltipMessage={tooltipMessage}
      dropdownMenuShouldHaveWidthOfButton
      dropdownMenuType={dropdownMenuType}
      fullWidth
      id={id}
      value={selectedConfirmationOptionId}
      variant='form'
    >
      <DropdownMenuToggler className={togglerClassName}>{selectedConfirmationOptionName}</DropdownMenuToggler>
      {confirmationOptions.map(({ confirmationOptionId, name }) => (
        <DropdownMenuItem
          key={confirmationOptionId}
          onClick={() => onChange(confirmationOptionId)}
          selected={confirmationOptionId === selectedConfirmationOptionId}
        >
          {name}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};

ConfirmationOption.propTypes = {
  id: PropTypes.string,
  dropdownMenuType: DropdownMenuTypePropType,
  confirmationOptions: PropTypes.arrayOf(
    PropTypes.shape({
      confirmationOptionId: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  selectedConfirmationOptionId: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

export default ConfirmationOption;
